import { Button } from "@/components/ui/button";
import { useWidgetStore } from "@/stores/widget-store";
import { saveWidgetConfig } from "@/services/widget";
import { useToast } from "@/hooks/use-toast";
import { useState } from "react";

export const WidgetPublish = () => {
  const [isPublishing, setIsPublishing] = useState(false);
  const widgetConfig = useWidgetStore((state) => state.config);
  const { toast } = useToast();

  const handlePublish = async () => {
    try {
      setIsPublishing(true);

      await saveWidgetConfig(widgetConfig);

      toast({
        title: "Changes published successfully",
        variant: "success",
      });
    } catch {
      toast({
        title: "Failed to publish changes",
        variant: "destructive",
      });
    } finally {
      setIsPublishing(false);
    }
  };

  return (
    <Button
      className="cy:rounded cy:text-base!"
      onClick={handlePublish}
      disabled={isPublishing}
    >
      {isPublishing ? "Applying..." : "Apply changes"}
    </Button>
  );
};
